<template>
  <div>
    <v-toolbar flat style="margin-left: -10px;padding: 0 85px 0 0;background-color:transparent">
      <v-toolbar-title>
        <h5 style="font-weight: 500;color:rgba(0, 0, 0, 0.47);font-size: 12px"><v-icon style="font-size: 20px;">mdi-counter</v-icon> &nbsp;&nbsp;&nbsp;&nbsp;{{ $t('menuType.queue') }}&nbsp;&nbsp;&nbsp;&nbsp;</h5>
      </v-toolbar-title>
      <!--v-divider vertical  style="margin: 0 15px 0 15px;" /-->

      <div
        v-show="!collapseContent"
        style="padding: 0 10px 10px 10px;"
      >
        <v-text-field
          v-model="content.QueueID"
          append-icon="mdi-search"
          :label="$t('ID')"
          hideDetails
          @input="handleChangeIsModified"
        />
      </div>
    </v-toolbar>
  </div>
</template>

<script>
  import axios from 'axios'
  import api from '@/services/api'
  export default {
    props: {
      content: {
        type: Object,
        required: true
      },
      collapseContent: {
        type: Boolean,
        default: false,
      },
    },
    data: () => ({
    }),
    computed: {
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      },
    },
    mounted() {
    },
    methods: {      
      handleChangeIsModified () {
        this.$store.state.app.isModified = false
      }
    }
  }
</script>

<style scoped>
</style>

